<div
  (click)="showListingDetails()"
  aria-hidden="true"
  tabindex="0"
  class="relative overflow-hidden rounded-lg bg-white shadow-sm dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10 flex flex-col hover:shadow-md dark:hover:bg-gray-800/70 transition cursor-pointer focus:outline-none"
>
  @if (listing().saleType === 'homesite') {
    <app-homesite-listing-card [initialRender]="initialRender()" [listing]="listing()" />
  } @else {
    <app-home-listing-card [initialRender]="initialRender()" [listing]="listing()" />
  }
</div>
